import {css} from '@yandex-delivery/blocks/theme/css'

export const leading = css`
  padding-inline-start: 0 !important; // Переопределил свойство у <Text> компонента
`

export const centered = css`
  && {
    align-items: center;
  }
`

export const trailing = css`
  inline-size: max-content;
`
